var _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlertWithDotIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0003 2.16663C5.6741 2.16663 2.16699 5.67373 2.16699 9.99996C2.16699 14.3262 5.6741 17.8333 10.0003 17.8333C14.3266 17.8333 17.8337 14.3262 17.8337 9.99996C17.8337 5.67373 14.3266 2.16663 10.0003 2.16663ZM1.16699 9.99996C1.16699 5.12144 5.12181 1.16663 10.0003 1.16663C14.8788 1.16663 18.8337 5.12144 18.8337 9.99996C18.8337 14.8785 14.8788 18.8333 10.0003 18.8333C5.12181 18.8333 1.16699 14.8785 1.16699 9.99996ZM10.0003 6.16663C10.2765 6.16663 10.5003 6.39048 10.5003 6.66663V10.8333C10.5003 11.1094 10.2765 11.3333 10.0003 11.3333C9.72418 11.3333 9.50033 11.1094 9.50033 10.8333V6.66663C9.50033 6.39048 9.72418 6.16663 10.0003 6.16663Z",
    fill: "#23252F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8337 13.3333C10.8337 13.7935 10.4606 14.1666 10.0003 14.1666C9.54009 14.1666 9.16699 13.7935 9.16699 13.3333C9.16699 12.8731 9.54009 12.5 10.0003 12.5C10.4606 12.5 10.8337 12.8731 10.8337 13.3333Z",
    fill: "#23252F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    fill: "#D12D36"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlertWithDotIcon);
export default ForwardRef;